<template>
    <div class="md-content">
        <md-toolbar md-elevation="1">
            <label v-if="current">{{current.title}}</label>
            <div class="md-toolbar-section-end">
                <md-button @click="deleteConfirmation" :disabled="current == null" class="md-raised md-primary ">
                    <md-icon>delete</md-icon>
                </md-button>
                <md-button @click="onAdd" class="md-raised md-primary">
                    <md-icon>add</md-icon>
                </md-button>
            </div>
        </md-toolbar>
        <md-table v-if="items" v-model="items" @md-selected="onSelect">
            <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
                <md-table-cell md-label="Titre">{{ item.title }}</md-table-cell>
                <md-table-cell md-label="Description">{{ item.description }}</md-table-cell>
            </md-table-row>
        </md-table>

        <div v-if="isAdd" class="md-my-3 md-layout md-alignment-center-center">
            <div class="md-layout-item ">
                <md-field>
                    <label for="newPermission">nouvelle permission</label>
                    <md-select v-model="new_name" name="newPermission" id="newPermission" md-dense>
                        <md-option v-for="(item, index) in permissions" :value="item.name" :index="index" :key="index" >{{item.title}}</md-option>
                    </md-select>
                </md-field>
            </div>
            <div class="md-layout-item">
                <md-button v-on:click="addConfirm" class="md-raised md-primary">
                    Ok
                </md-button>
                <md-button v-on:click="addCancel" class="md-raised md-primary">
                    Cancel
                </md-button>
            </div>
        </div>

        <md-dialog-confirm :md-active.sync="isDelete"
                           md-title="Attention"
                           md-content="Voulez-vous vraiment supprimer cette permission ?"
                           md-confirm-text="Oui"
                           md-cancel-text="Non"
                           @md-confirm="deleteConfirm" />

    </div>
</template>
<style scoped>
    .md-table-row.md-selected, .md-table-row.md-selected-single {
        background-color: var(--md-theme-default-primary) !important;
    }

    .md-toolbar.md-theme-default {
        color: var(--md-theme-default-primary) !important;
    }
</style>

<script>
    import { apiSecurityExtension } from '@/mixins/apiSecurityExtension.js';

    export default {
        name: 'role-permission',
        mixins: [apiSecurityExtension],
        props: ['items'],
        data: () => ({
            current: null,
            permissions: null,
            new_name: null,
            isAdd: false,
            isDelete: false,
        }),

        mounted:
            function () {
                this.permissionsRead();
                this.dataRead();
            },

        methods: {
            dataRead: async function () {

                let data = await this.SecurityRolePermissionListById(this.$route.params.id);
                if (data) {
                    this.$emit("update:items", data);
                } else { 
                    this.$emit("update:items", []);
                }
            },
            permissionsRead: async function () {

                let data = await this.SecurityPermissionList();
                if (data) {
                    this.permissions = data;
                } else { 
                    this.permissions = [];
                }
            },
 
            onAdd: function () {
                this.isAdd = true;
            },
            onSelect(item) {
                this.current = item;
            },

            deleteConfirmation: function () {
                this.isDelete = true;
            },
            addConfirm: function () {
                for (let i = 0; i < this.permissions.length; i++) {
                    if (this.permissions[i].name === this.new_name
                        && this.items.findIndex(x => x.name === this.new_name) === -1) {
                        this.items.push(this.permissions[i]);
                    }
                }

                this.isAdd = false;
            },
            addCancel: function () {
                this.isAdd = false;
            },
            deleteConfirm: function () {
                for (let i = 0; i < this.items.length; i++) {
                    if (this.items[i].name === this.current.name) {
                        this.items.splice(i, 1);
                    }
                }
            },
        },

        components: {
        }
    }
</script>